import React, {useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {CSSTransition} from 'react-transition-group'
import {toast} from 'react-toastify'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {KTSVG} from '../../../../../../_gori/helpers'
import BlurredText from '../../../../../../_gori/partials/widgets/mixed/BlurredText'
import SettingsService from '../../../core/_requests'

export const ApiKeys = () => {
  const intl = useIntl()
  const [integrations, setIntegrations] = useState<any>(null)

  useEffect(() => {
    const fetchIntegrations = async () => {
      try {
        const res = await SettingsService.getAccountIntegrations()
        setIntegrations(res)
      } catch (error) {
        console.error(error)
        toast.error(intl.formatMessage({id: 'ERROR_OCCURRED'}))
      }
    }
    fetchIntegrations()
  }, [intl])

  const keys = useMemo(
    () => ({
      V2_STAGING: [
        {
          label: intl.formatMessage({id: 'STAGING'}) + ' ' + intl.formatMessage({id: 'V2_API'}),
          value: 'https://staging.api.goricompany.com/v2',
          hideBtn: true,
        },
        {
          label: intl.formatMessage({id: 'STAGING'}) + ' ' + intl.formatMessage({id: 'CLIENT_ID'}),
          value: integrations?.gori_staging?.client_id,
        },
        {
          label:
            intl.formatMessage({id: 'STAGING'}) + ' ' + intl.formatMessage({id: 'CLIENT_SECRET'}),
          value: integrations?.gori_staging?.client_secret,
        },
      ],
      V2_PRODUCTION: [
        {
          label: intl.formatMessage({id: 'V2_API'}),
          value: 'https://api.goricompany.com/v2',
          hideBtn: true,
        },
        {
          label: intl.formatMessage({id: 'CLIENT_ID'}),
          value: integrations?.gori_production?.client_id,
        },
        {
          label: intl.formatMessage({id: 'CLIENT_SECRET'}),
          value: integrations?.gori_production?.client_secret,
        },
      ],
    }),
    [integrations, intl]
  )

  const initialRevealedState = useMemo(() => {
    return Object.fromEntries(
      Object.keys(keys).flatMap((key) => keys[key].map((item) => [item.value, false]))
    )
  }, [keys])
  const [revealed, setRevealed] = useState<any>(initialRevealedState)

  const updateRevealed = (value, newValue) => {
    setRevealed((prevState) => ({
      ...prevState,
      [value]: newValue,
    }))
  }

  return (
    <>
      <div className='d-flex justify-content-start w-100 settings-header table-settings-header'>
        <h1 className='d-flex flex-column text-dark fw-boldest my-0 fs-1'>
          {intl.formatMessage({id: 'AUTHENTICATION_TOKENS'})}
        </h1>
      </div>
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <div className='card table-content h-100'>
          {/* <div className='table-content--inset-inner h-100'> */}
          <div className='card-body pt-0 d-flex flex-column p-0'>
            <div className='dataTables_wrapper dt-bootstrap4 no-footer d-flex flex-column flex-fill'>
              <div className='scroll-x flex-fill scroll-y-clip'>
                <table className='table align-middle table-row-bordered fs-6 gy-4 dataTable no-footer'>
                  {Object.entries(keys).map(([title, data]) => {
                    return (
                      <>
                        <thead className='border-gray-200 fs-6 fw-bold bg-light api-keys-table-header'>
                          <tr>
                            <th
                              colSpan={3}
                              className='py-3 text-uppercase text-gray-700 table-content--inset-inner'
                            >
                              {intl.formatMessage({id: title})}
                            </th>
                          </tr>
                        </thead>
                        <tbody className='fs-6 fw-bold text-gray-600 api-keys-table-body'>
                          {data.map((key) => {
                            return (
                              <tr role='row' key={key.value}>
                                <td role='cell' className='py-3 table-content--inset-inner'>
                                  <div className='w-250px text-truncate'>{key.label}</div>
                                </td>
                                <td role='cell' className='py-3'>
                                  <BlurredText
                                    text={key.value}
                                    revealed={
                                      key.hideBtn ? !revealed[key.value] : revealed[key.value]
                                    }
                                    setRevealed={(newValue) => {
                                      if (!key.hideBtn) {
                                        updateRevealed(key.value, newValue)
                                      }
                                    }}
                                  />
                                </td>
                                <td role='cell' className='py-3'>
                                  {!key.hideBtn && key.value && (
                                    <span
                                      className='btn btn-sm btn-icon position-absolute ms-n9'
                                      onClick={() =>
                                        updateRevealed(key.value, !revealed[key.value])
                                      }
                                    >
                                      {revealed[key.value] ? (
                                        <i className='bi bi-eye fs-2' />
                                      ) : (
                                        <i className='bi bi-eye-slash fs-2' />
                                      )}
                                    </span>
                                  )}
                                  <CopyToClipboard
                                    text={key.value}
                                    onCopy={() => toast.success(intl.formatMessage({id: 'COPIED'}))}
                                  >
                                    <div>
                                      <div className='btn btn-active-color-primary btn-icon btn-sm btn-outline-light'>
                                        <KTSVG
                                          path='/media/gori/account/copy.svg'
                                          className='svg-icon'
                                        />
                                      </div>
                                    </div>
                                  </CopyToClipboard>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </>
                    )
                  })}
                </table>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </CSSTransition>
    </>
  )
}
